import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/land/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: ""
    }
  },
  {
    // FlowCarousel 组件效果演示，未接入落地页。
    // 刻意用一级路径：public/init.js 用 "./landing-sdk-v1.1.1.js" 这种相对地址加载
    // 埋点脚本，多级路径下会被 history fallback 解析成 HTML 而报错。
    path: "/flow-carousel",
    name: "DemoFlowCarousel",
    component: () =>
      import(/* webpackChunkName: "demo" */ "../views/demo/flowCarousel.vue"),
    meta: {
      title: "FlowCarousel Demo"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  next();
});

export default router;
